module.exports = __webpack_public_path__ + "static/media/icn_map_pin_green.5a34d345.svg";